import { CaptionText } from '../../styles/FontStyles';
import { UserImageCircle } from '../../styles/GlobalComponents';
import { Partner } from './CashbackBonusStyled';
import moment from 'moment';
import { USDT } from '../../helpers/helperFunctions';
import { color } from '../../styles/GlobalStyles';
import { DirectUser } from './CashbackBonus.types';

interface PartnerComponentProps {
  directUser: DirectUser;
}

export const PartnerComponent = ({ directUser }: PartnerComponentProps) => {
  const disabled = !directUser.id;

  return (
    <Partner>
      <UserImageCircle
        image={directUser.profileImageUrl}
        avatar
        size='40px'
        fontSize='18px'
        avatarSize={'20'}
        margin={'0 0 4px 0'}
        disabled={disabled}
      />
      <div style={{ width: '100%' }}>
        <CaptionText
          center
          mb={
            !directUser?.package?.datePaid &&
            !directUser?.package?.price &&
            disabled
              ? '18'
              : ''
          }
          color={color.colors.neutral900}>
          <div className='truncated'>
            <div style={{ width: '100%' }}>{directUser.username}</div>
          </div>
        </CaptionText>
        {directUser?.package?.datePaid &&
          directUser?.package?.price &&
          !disabled && (
            <CaptionText color={color.colors.neutral900}>
              {moment(directUser?.package?.datePaid).format('D.MM.YYYY')}
              <br />
              {directUser?.package?.price || '0.00'} {USDT}
            </CaptionText>
          )}

        {disabled && (
          <CaptionText color={color.colors.neutral50}>.</CaptionText>
        )}
      </div>
    </Partner>
  );
};
